angular.module('logbook')
  .controller('report-manager', ['$scope', '$http', '$location', '$filter', '$q', '$rootScope', 'errorHandler',
      function($scope, $http, $location, $filter, $q, $rootScope, errorHandler) {
     $scope.displayingSchedules = $rootScope.selectedLog.role === 'READ' ? false : !!$location.search()['scheduled'];
     $scope.reports = [];
     $scope.srcReports = [];
     $scope.reportMap = {};
     $scope.menuSelected = {};
     $scope.reportToMenuItemMap = {};
     $scope.loadedReports = false;
     $scope.loadingStates = {
         isMenuBarItem: {},
         isViewNotesFilter: {}
          };
         
      /**
       * Converts a UserReportMenuItem into one usable by the UI
       * @param item
       * @return {*}
       */
     function convertMenuBarItem(item)
     {
         if (item.isViewNotesFilter === null)
             item.isViewNotesFilter = 'default';
         else
             item.isViewNotesFilter = item.isViewNotesFilter.toString();
         
         if (item.isMenuBarItem === null)
             item.isMenuBarItem = 'default';
         else
             item.isMenuBarItem = item.isMenuBarItem.toString();
         
         return item;
  }
     
     $scope.refreshReports = function() {
        var params = {
              'log': $scope.selectedLog.id,
              'templateTrigger': false,
               saveInProgress: false,
               isDraft: false,
               activeRevision: true,
               projection: 'reportProjectionSmall'
        };
        if( !$scope.showAllReports )
           params['myReports'] = true;
        return $http.get('/api/reports', {
           params: params
        }).then(function(result)
        {
           $scope.reports = result.data._embedded.reports;
           $scope.reportMap = {};
           $scope.reports.forEach(function(report) {
               $scope.reportMap[report.complexObject.id] = report;
           });
           
           params.isDraft = true;
           delete params.activeRevision;
           return $http.get('/api/reports', {
               params: params
           })
               .then(function(results)
               {
                   results.data._embedded.reports.forEach(function (report)
                   {
                       report.isDraft = true;
                       if (!$scope.reportMap[report.complexObject.id])
                           $scope.reports.push(report);
                       
                       $scope.reportMap[report.complexObject.id] = report;
                   });
                   $scope.getReports().forEach(function(report)
                   {
                       report.isCurrentlyEditable = (report.defaultRole && report.defaultRole.id === 2)
                           || $scope.selectedLog.role == 'ADMIN';
                       
                       report.users && report.users.forEach(function(user) {
                           if(user.user.id == $scope.selectedLog.activeLogUser.id )
                           {
                               if( user.role && user.role.id == 2 )
                                   report.isCurrentlyEditable = true;
                               else if( $scope.selectedLog.role != 'ADMIN' )
                                   report.isCurrentlyEditable = false;
                           }
        
                       });
                   })
               })
        })
     };
     
     $scope.getReports = function()
     {
         $scope.srcReports = Object.values($scope.reportMap);
         return $scope.reports = Object.values($scope.reportMap);
     };
     
     $scope.deleteReport = function(report)
     {
        function reportDeleted()
        {
            delete $scope.reportMap[report.complexObject.id]
            if( $scope.menuSelected[report.complexObject.id] )
            {
                $rootScope.$broadcast('reportMenuItemsUpdated');
                delete $scope.menuSelected[report.complexObject.id];
                delete $scope.reportToMenuItemMap[report.complexObject.id];
            }
            $scope.getReports();
        }
        
        return $http.delete(report.complexObject._links.self.href,
            {
                noErrorPopup: true
            }).then(function(result) {
                reportDeleted();
        }, function(error)
        {
            $scope.fetchReport(report.complexObject.id, true)
                .then(function(_report)
                {
                    // If the report exists, display an error message.
                    // If the report no longer exists, continue to process as deleted.
                    if (!!_report)
                        errorHandler.handle('An error occurred while deleting this report', report.id + ' error: ' + error, true)
                    else
                    {
                        reportDeleted()
                    }
                })
        });
     };
     
      $scope.getUserReportMenuItems = function()
      {
          return $http.get('/api/userReportMenuItems', {
              params: {
                  userDetails: $scope.user.id
              }
          })
      };
     
     $scope.refreshUserReportMenuItems = function()
     {
         $scope.loadedReports = false;
         return $q.all([
             $scope.refreshReports(),
             $scope.getUserReportMenuItems()
         ]).then(function(results) {
             $scope.reports.forEach(function(report)
             {
                 $scope.menuSelected[report.complexObject.id] = {
                     id: -1,
                     isMenuBarItem: 'default',
                     isViewNotesFilter: 'default'
                 }
             });
             results[1].data._embedded.userReportMenuItems.forEach(function(item)
             {
                 $scope.menuSelected[item.reportObject.id] = convertMenuBarItem(item);
             });
             $scope.originalMenuSelected = JSON.parse(JSON.stringify($scope.menuSelected));
             $scope.loadedReports = true;
         });
     };
     
     $scope.refreshUserReportMenuItems();
     
     $scope.getReportHref = function(report) {
         if (!$scope.selectedLog)
             return '';
         
         return '/#/report-view?log='+$scope.selectedLog.id+'&report='+report.id + '&latest=' + report.complexObject.id;
     };
     
     $scope.getters = {
         name: (report) => `${report.createdBy.firstName} ${report.createdBy.lastName}`
     }
     
     $scope.complexManagerBound = function(cpxScope)
     {
         var report = cpxScope.complexObject;
         
         function updateCpxReport(newReport)
         {
             newReport.$$hashKey = report.$$hashKey;
             newReport.detailMode = true;
    
             $scope.reportMap[newReport.complexObject.id] = newReport;
             $scope.reports = $scope.getReports();
    
             report = newReport;
             $rootScope.$broadcast('reportMenuItemsUpdated');
         }
         
         function hasPermission(report)
         {
             var enabled = (report.defaultRole && report.defaultRole.name == 'WRITE'
             || $scope.selectedLog.role == 'ADMIN');
             
             if (enabled) return true;
             
             report.users && report.users.forEach(function(user) {
                 if (user.user.id == $scope.selectedLog.activeLogUser.id) {
                     if (user.role && user.role.id == 2)
                         enabled = true;
                     else if ($scope.selectedLog.role != 'ADMIN')
                         enabled = false;
                 }
             });
             return enabled;
         }
         
         cpxScope.setDeleteAvailablePredicate(hasPermission);
         cpxScope.setPublishAvailablePredicate(hasPermission);
         cpxScope.setCommentAvailablePredicate(hasPermission);
         
         cpxScope.addEditCallback(function(report)
         {
             if (report.isDraft)
                 $location.url('/report-editor?log=' + $scope.selectedLog.id + '&draft=' + report.complexObject.id);
             else
                 $location.url('/report-editor?log=' + $scope.selectedLog.id + '&report=' + report.id)
         });
         
         cpxScope.addRevisionMadeActiveCallback(updateCpxReport);
         
         cpxScope.addOnCopyCallback(function(report)
         {
            var reportCopy = {
                log: $scope.selectedLog._links.self.href,
                outputType: '/api/reportOutputTypes/1',
                name: $filter('date')(new Date(), 'yyyy-MM-dd HH:mm'),
                saveInProgress: false,
                defaultMenuBarItem: false,
                defaultViewNotesFilter: false,
                copyReport: { 'id': report.id }
            };

            $http.post('/api/reports', reportCopy)
                .then(function(result) {
                    $http.patch(result.data._links.self.href, { saveInProgress: false })
                        .then(function(result) {
                            $location.url('/report-editor').search('report', result.data.id);
                        });
                });
         });
         
         cpxScope.addOnComplexObjectChangedCallback(function(newObj, oldObj)
         {
             // Verify history objects exist. If not, the report may have been deleted.
             if (!cpxScope.historyObjsMap.getAll().length)
             {
                 if (newObj && newObj.complexObject)
                    $scope.fetchReport(newObj.complexObject.id, true)
                        .then(function(result)
                        {
                            // If the report object has been deleted, close the complex mgr and
                            // remove the report from the report map.
                            if (!result)
                            {
                                cpxScope.dismiss();
                                delete $scope.reportMap[newObj.complexObject.id];
                                $scope.reports = $scope.getReports();
                            }
                        })
                 return;
             }
             
             if (!newObj || !oldObj || newObj.id === oldObj.id)
                 return;
             
             updateCpxReport(newObj);
         });
         
         cpxScope.addDeleteCallback(function(deleted, newReport)
         {
             if (deleted === newReport)
                 return;
             
             if (!newReport)
             {
                 delete $scope.reportMap[deleted.complexObject.id];
                 $scope.reports = $scope.getReports();
                 return;
             }
             
             newReport.$$hashKey = deleted.$$hashKey;
             newReport.detailMode = true;
             
             $scope.reportMap[newReport.complexObject.id] = newReport;
             $scope.reports = $scope.getReports();
         });
         cpxScope.addOnCloseCallback(function()
         {
             delete report.detailMode;
         })
     };
     
     $scope.fetchReport = function(id, usingComplexId)
     {
         var params = {
             log: $scope.selectedLog.id,
             templateTrigger: false,
             projection: 'reportProjectionSmall'
         };
         
         params[(!!usingComplexId) ? 'complexObject.id' : 'id'] = id;
         
         return $http.get('/api/reports', {
             noErrorPopup: true,
             params: params
         })
             .then(function(results)
             {
                 return results.data._embedded.reports[0];
             }, function(error)
             {
                 return null;
             })
     }
     
     $scope.changeReportMenuItemField = function(report, field)
     {
         if (!['isViewNotesFilter', 'isMenuBarItem'].includes(field))
             return;
         
         var menuItem = $scope.menuSelected[report.complexObject.id];
    
         var toSend = {};
         toSend[field] = menuItem[field];
    
         switch (toSend[field])
         {
             case 'true':
                 toSend[field] = true;
                 break;
             case 'false':
                 toSend[field] = false;
                 break;
             case 'default':
                 toSend[field] = null;
                 break;
             default:
                 return;
         }
         return $q(function(resolve)
         {
             $scope.loadingStates[field][report.complexObject.id] = true;
             if (menuItem.id > -1)
                 resolve($http.patch(menuItem._links.self.href,  toSend, { suppressExclusiveRequest: true }));
             else
             {
                 toSend.reportObject = $location.absUrl().split("#")[0] + 'api/reportObjects/' + report.complexObject.id;
                 toSend.userDetails = $location.absUrl().split("#")[0] + 'api/userDetails/' + $scope.user.id;
                 
                 resolve($http.post( '/api/userReportMenuItems', toSend, { suppressExclusiveRequest: true })
                     .then(function(result)
                     {
                         $scope.menuSelected[report.complexObject.id] = convertMenuBarItem(result.data);
                     }))
             }
         })
             .then(function()
             {
                 if (field === 'isMenuBarItem')
                     $rootScope.$broadcast('reportMenuItemsUpdated');
             })
             .catch(function()
             {
                 menuItem[field] = $scope.originalMenuSelected[report.complexObject.id][field];
             })
             .finally(function()
             {
                 delete $scope.loadingStates[field][report.complexObject.id];
                 $scope.originalMenuSelected = JSON.parse(JSON.stringify($scope.menuSelected));
             });
     };
     
     $scope.setAllReports = function(value) {
         $scope.showAllReports = !!value;
     }
     
     $scope.setDisplayingSchedules = function(value){
         $scope.displayingSchedules = ($rootScope.user.role === 'READ') ? false : !!value
         $location.search('scheduled', $scope.displayingSchedules ? true : null).replace();
     }
     
  }]);